import { render, staticRenderFns } from "./DiseaseShow.vue?vue&type=template&id=63b06862&scoped=true&"
import script from "./DiseaseShow.vue?vue&type=script&lang=js&"
export * from "./DiseaseShow.vue?vue&type=script&lang=js&"
import style0 from "./DiseaseShow.vue?vue&type=style&index=0&id=63b06862&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b06862",
  null
  
)

export default component.exports